import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=5b3bf1a0&scoped=true&"
import script from "./Pay.vue?vue&type=script&lang=js&"
export * from "./Pay.vue?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=5b3bf1a0&prod&lang=css&"
import style1 from "./Pay.vue?vue&type=style&index=1&id=5b3bf1a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3bf1a0",
  null
  
)

export default component.exports